
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.345","height":"12.345","viewBox":"0 0 12 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 150778","d":"M12.084 10.77l-4.6-4.6 4.6-4.6a.958.958 0 000-1.314.958.958 0 00-1.314 0l-4.6 4.6-4.6-4.6a.958.958 0 00-1.314 0 .958.958 0 000 1.314l4.6 4.6-4.6 4.6a.958.958 0 000 1.314.958.958 0 001.314 0l4.6-4.6 4.6 4.6a.958.958 0 001.314 0 .958.958 0 000-1.314z","fill":"#8d98aa"}})])
          )
        }
      }
    